import { formApi, formsApi } from 'app/services/api';

import { FeatureFlag } from 'constants/featureFlags';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectFeatureFlagByKey } from 'store/global/selectors';

export const FORM_PDF_ACTION_TYPE = createNamedActions('formPdf', {
  UPDATE_FORM_TEMPLATE: 'UPDATE_FORM_TEMPLATE',
  UPDATE_TEMPLATE_ELEMENT: 'UPDATE_TEMPLATE_ELEMENT',
  UPDATE_TEMPLATE_ELEMENT_MULTIPLE_OPTIONS: 'UPDATE_TEMPLATE_ELEMENT_MULTIPLE_OPTIONS',
  CREATE_TEMPLATE_ELEMENT: 'CREATE_TEMPLATE_ELEMENT',
  DELETE_TEMPLATE_ELEMENT: 'DELETE_TEMPLATE_ELEMENT',
  RESET_PDF_METADATA: 'RESET_PDF_METADATA',
  GET_FORM_TEMPLATE_FROM_HISTORY: 'GET_FORM_TEMPLATE_FROM_HISTORY',
  GET_FORM_TEMPLATE: 'GET_FORM_TEMPLATE',
  SET_PREVIEWING_FORM_TEMPLATE: 'SET_PREVIEWING_FORM_TEMPLATE',
});

export const updateTemplateElementAction = data => dispatch =>
  dispatch({
    type: FORM_PDF_ACTION_TYPE.UPDATE_TEMPLATE_ELEMENT,
    payload: data,
  });

export const updateTemplateElementMultipleOptionsAction = data => dispatch =>
  dispatch({
    type: FORM_PDF_ACTION_TYPE.UPDATE_TEMPLATE_ELEMENT_MULTIPLE_OPTIONS,
    payload: data,
  });

export const createTemplateElementAction = data => dispatch =>
  dispatch({
    type: FORM_PDF_ACTION_TYPE.CREATE_TEMPLATE_ELEMENT,
    payload: data,
  });

export const deleteTemplateElementAction = data => dispatch =>
  dispatch({
    type: FORM_PDF_ACTION_TYPE.DELETE_TEMPLATE_ELEMENT,
    payload: data,
  });

export const resetPdfMetadataAction = () => dispatch =>
  dispatch({
    type: FORM_PDF_ACTION_TYPE.RESET_PDF_METADATA,
  });

export const getPdfFormTemplateFromHistoryAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const isFormsConsolidationEnabled = selectFeatureFlagByKey(
      FeatureFlag.FormsConsolidationEnabled,
    )(getState());

    const historyApi = isFormsConsolidationEnabled ? formsApi : formApi;

    const { data } = await historyApi.getFormHistorySnapshotPdfByEntryId(params);

    return dispatch({
      type: FORM_PDF_ACTION_TYPE.GET_FORM_TEMPLATE_FROM_HISTORY,
      payload: data,
    });
  },
);

export const getPreviewingPdfFormTemplateAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const isFormsConsolidationEnabled = selectFeatureFlagByKey(
      FeatureFlag.FormsConsolidationEnabled,
    )(getState());

    const previewApi = isFormsConsolidationEnabled ? formsApi : formApi;

    const { data } = await previewApi.getFormPreviewPdf(params);

    return dispatch({
      type: FORM_PDF_ACTION_TYPE.SET_PREVIEWING_FORM_TEMPLATE,
      payload: data,
    });
  },
);
